import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-cream" data-id="element-0" data-mp="31bi7xhgaoacs">
      <MetaPixel data-id="element-1" data-mp="31cjjro54x0vk" />
      <CountdownBar data-id="element-2" data-mp="2wk9y4kb1ymz3" />
      <main data-id="element-3" data-mp="2wiyy8vkq9zd9">
        <Hero data-id="element-4" data-mp="2wj8f9tnsow6t" />
        <StatsBar data-id="element-5" data-mp="2wip54z4dzc3c" />
        <Difference data-id="element-6" data-mp="2wi5lndz38fn7" />
        <WhatsInside data-id="element-7" data-mp="28u5z6q8t7bef" />
        <InsidePages data-id="element-8" data-mp="28te0v7ntuzkg" />
        <Bonuses data-id="element-9" data-mp="28suvsrja05nu" />
        <Offer data-id="element-10" data-mp="28sb9kymlev40" />
        <Testimonials data-id="element-11" data-mp="23vck4tdvjcc5" />
        <Faq data-id="element-12" data-mp="23vul23bheeqe" />
      </main>
      <Footer data-id="element-13" data-mp="23ujlkfp2jt53" />
    </div>;
}